import React from "react";
import { PageHeader } from "@finitless/shared/components";
import { Icon } from "../../UIElements/Icon";
import "../states.css";

/**
 * Centralized error state component for OverviewPage
 * @param {Object} props - Component props
 * @param {Object} props.selectedBrand - Selected brand for header
 * @param {string} props.welcomeMessage - Welcome message to display
 * @param {Error} props.error - Error object to display
 * @param {string} props.fallbackMessage - Fallback message if no specific error message
 */
const ErrorState = ({
  selectedBrand,
  welcomeMessage,
  error,
  fallbackMessage = "Unable to fetch metrics. Showing sample data instead.",
}) => {
  const errorMessage = error?.message || fallbackMessage;

  return (
    <div>
      <PageHeader title="Overview" selectedBrand={selectedBrand}>
        <p className="ui-state-muted text-lg">{welcomeMessage}</p>
      </PageHeader>

      <div
        role="alert"
        className="ui-state-error mb-6 rounded-[var(--od-radius-panel)] border p-6"
      >
        <div className="flex items-center gap-3">
          <div aria-hidden="true">
            <Icon name="AlertTriangle" className="h-6 w-6" />
          </div>
          <div>
            <h3 className="text-lg font-medium">
              Failed to load dashboard data
            </h3>
            <p className="mt-1 text-sm">{errorMessage}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ErrorState };
